import React, { useState, useEffect } from 'react';
import { Card, Button } from 'react-bootstrap';
import { collection, query, where, getDocs, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase';
import '../css/Leaderboard.css';

const Leaderboard = ({ onClose, animate, quizDate, playerData }) => {
  const [leaderboard, setLeaderboard] = useState([]);
  
  useEffect(() => {
    const fetchLeaderboardData = async () => {
      try {
        // Query to get performances for the specific quiz date
        const q = query(
          collection(db, 'performances'),
          where('date', '>=', new Date(quizDate).toISOString().slice(0, 10) + 'T00:00:00.000Z'),
          where('date', '<', new Date(new Date(quizDate).getTime() + 86400000).toISOString().slice(0, 10) + 'T23:59:59.999Z'),
          orderBy('points', 'desc'),
          limit(10)
        );

        const querySnapshot = await getDocs(q);
        const leaderboardData = await Promise.all(
          querySnapshot.docs.map(async (doc) => {
            const performanceData = doc.data();
            const playerQuery = query(collection(db, 'players'), where('id', '==', performanceData.playerId));
            const playerSnapshot = await getDocs(playerQuery);
            if (!playerSnapshot.empty) {
              const playerInfo = playerSnapshot.docs[0].data();
              return {
                ...performanceData,
                playerName: playerInfo.name,
                avatar: playerInfo.avatar,
                gender: playerInfo.gender
              };
            } else {
              console.error(`Player document not found for playerId: ${performanceData.playerId}`);
              return {
                ...performanceData,
                playerName: 'Unknown',
                avatar: 'unknown'
              };
            }
          })
        );

        // Filter out players with zero points
        const filteredLeaderboard = leaderboardData.filter(player => player.points > 0);

        setLeaderboard(filteredLeaderboard);
      } catch (error) {
        console.error('Error fetching leaderboard data:', error);
      }
    };

    fetchLeaderboardData();
  }, [quizDate]);

  return (
    <Card className={`leaderboard-card ${animate ? 'show' : 'hide'}`}>
      <Card.Body>
        <h4 className="card-title mb-4">Leaderboard <span>Top 10</span></h4>
        <Button className="lb-close" onClick={onClose}>
          <i className="fa-solid fa-xmark"></i>
        </Button>

        <div className="leaderboard-list rl">
          {leaderboard.map((player, index) => (
            <div
              key={player.playerId}
              className={`leaderboard-item ${player.playerId === playerData.id ? 'mycard-lb' : ''}`}
            >
              <span className="rank">{index + 1}</span>
              <img
                src={player.avatar}
                alt="Player"
                className="player-image"
              />
              <div className="player-info">
                <span className="player-name">{player.playerName}</span>
              </div>
              <span className="player-points">{player.points}</span>
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default Leaderboard;